function roundToTwo(value) {
    return Math.round(Number(value) * 100) / 100;
}

export function evaluateMathOperation(leftOperand, rightOperand, condOperator, isVal, dfi ,flipSign) {
    if(dfi=== undefined || dfi === null  )
        dfi = 0;
     if(isVal === undefined)
        isVal = false;
     if(flipSign === undefined)
        flipSign = false;
         // Trim only if the operand is a string
    if (typeof leftOperand === 'string') {
        leftOperand = leftOperand.trim();
    }
    if (typeof rightOperand === 'string') {
        rightOperand = rightOperand.trim();
    }
    if (condOperator === '=')  {
        const leftIsNumeric = !isNaN(Number(leftOperand)) && leftOperand !== '' && leftOperand !== null && leftOperand !== undefined;
        const rightIsNumeric = !isNaN(Number(rightOperand)) && rightOperand !== '' && rightOperand !== null && rightOperand !== undefined;
        if (leftIsNumeric && rightIsNumeric) {
            const leftRounded = Number(Number(leftOperand).toFixed(2));
            const rightRounded = Number(Number(rightOperand).toFixed(2));
            return leftRounded === rightRounded;
        }
        return leftOperand === rightOperand;
    }
    else if (condOperator === '<>') {
        return leftOperand !== rightOperand;
    }
    else if (condOperator === '<' || condOperator === '<=' || condOperator === '=<')  
    {
        // For validation use-cases (isVal === true), compare in natural order: left <= right
        // For legacy non-validation flows, keep the historical reversed semantics unless flipSign is set.
        if (flipSign) {
            return Number(leftOperand) <= Number(rightOperand);
        }
        if (isVal) {
            return Number(leftOperand) <= Number(rightOperand);
        }
        return Number(rightOperand) <= Number(leftOperand) ; 
    }
       
    else if (condOperator === '>' ||  condOperator === '>=' || condOperator === '=>')
    {
        // For validation use-cases (isVal === true), compare in natural order: left >= right
        // For legacy non-validation flows, keep the historical reversed semantics unless flipSign is set.
        if (flipSign) {
            return Number(leftOperand) >= Number(rightOperand);
        }
        if (isVal) {
            return Number(leftOperand) >= Number(rightOperand);
        }
        return Number(rightOperand) >= Number(leftOperand) ; // legacy reversed semantics
    }
        
    else if (condOperator === '+') return roundToTwo((Number(leftOperand) + Number(rightOperand)) * (1 - dfi));
    else if (condOperator === '-') return roundToTwo((Number(leftOperand) - Number(rightOperand)) * (1 - dfi));
    else if (condOperator === '*') return roundToTwo(Number(leftOperand) * Number(rightOperand) * (1 - dfi));
    else if (condOperator === '/') return roundToTwo(Number(leftOperand) / Number(rightOperand) * (1 - dfi));
}

// checks if value is empty or null or undefined
export function isEmpty(value){
    if (typeof value === 'string') {
        value = value.trim();
    }
    value = value ? value : null;
    return (value === undefined || value === null || value === '');
  }

// Safely get a query param value while preserving '+' characters (common in encrypted tokens)
export function getParamPreservePlus(search, name){
    if (!search) return null;
    const match = search.match(new RegExp(`[?&]${name}=([^&#]*)`));
    if (!match) return null;
    const raw = match[1];
    try {
        // Replace '+' with '%2B' before decoding so '+' is preserved
        return decodeURIComponent(raw.replace(/\+/g, '%2B'));
    } catch (err) {
        return raw;
    }
}

